import { ChatHistoryDetailPage } from './ChatHistoryDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/chat-history/$chatHistoryId/',
)({
  component: ChatHistoryDetailPage,
});
